import { usePhoneCallStore } from 'src/stores/phoneCall';

import { AbstractDirectPhoneCallGatewayStrategy } from 'src/components/phoneCall/phoneCallGateway/AbstractDirectPhoneCallGatewayStrategy';

import { CommandBus } from 'src/util/command/CommandBus';

type PhoneCallStore = ReturnType<typeof usePhoneCallStore>;

export abstract class AbstractPhoneCallGatewayWithHangupFunctionalityStrategy extends AbstractDirectPhoneCallGatewayStrategy {
	protected readonly phoneCallStore: PhoneCallStore;

	protected constructor(phoneCallStore: PhoneCallStore, commandBus: CommandBus, authenticatedUserId: number) {
		super(commandBus, authenticatedUserId);
		this.phoneCallStore = phoneCallStore;
	}

	protected setActiveCallId(callId: string) {
		this.phoneCallStore.setOutgoingCallWithHangupFunctionalityCallId({
			callId: callId,
		});
	}

	protected activeCallId(): null | string {
		return this.phoneCallStore.outgoingCallWithHangupFunctionalityCallId;
	}

	protected clearActiveCall() {
		this.phoneCallStore.setOutgoingCallWithHangupFunctionalityCallId({
			callId: null,
		});

		this.phoneCallStore.setTheNextOutgoingCallIdForACalledNumberAfterAGivenTimestamp({
			nextOutgoingCallIdForACalledNumberAfterAGivenTimestamp: null,
		});
	}
}
